import { render } from "./index.vue?vue&type=template&id=5bfb46aa&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=5bfb46aa&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5bfb46aa"

export default script